import { normalizeAuthList } from "@/constants/businessAccess"

export default defineNuxtRouteMiddleware(async to => {
  if (!to.path.startsWith("/support")) return

  const session = useAuthSession()
  try { await session.ensure() } catch { /* Keep offline sessions available. */ }
  const token = session.read()?.token
  const roles = normalizeAuthList(session.read()?.role)

  if (!token) return navigateTo({ path: "/user-profile", query: { redirect: to.fullPath, auth: "required" } })

  const isServiceDesk = roles.includes("SERVICE_DESK")
  const isSiteManager = roles.includes("SITE_MANAGER")
  if (!isServiceDesk && !isSiteManager) return navigateTo("/user-profile/business-access-denied")
  const isSiteReport = to.path.startsWith("/support/reports") || to.path.startsWith("/support/report-details")
  if (isSiteManager && !isServiceDesk && !isSiteReport) return navigateTo("/support/reports")
})
